import { CommonModule } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { ChangelogRelease } from '@vmspdb/definitions';

@Component({
  selector: 'vmspdb-ui-changelog-modal',
  imports: [CommonModule],
  templateUrl: './changelog-modal.component.html',
  styleUrl: './changelog-modal.component.scss',
})
export class ChangelogModalComponent {
  @HostBinding('attr.data-testid') testid = 'modal-changelog';

  releases: ChangelogRelease[] = [];
}
